import React, { useState } from "react";
import { Button } from 'react-bootstrap'
import { translateResourceString } from '../../util/translationUtility'
import UserNotes from "../../SharedComponents/Notes/UserNotes";

const WishlistUserNotes = ({
    ListName,
    SaveUserNotes,
    Notes
}) => {

    const [userNotes, setUserNotes] = useState(Notes);

    return (
        <div className='col-flex list-item'>
            <h4 className="headline headline-sm">Notes</h4>
            <UserNotes
                userNotes={userNotes}
                setUserNotes={setUserNotes}
             />
            <Button className='btn-secondary mt-2' bsSize="sm" 
                    onClick={() => SaveUserNotes(ListName, userNotes)}>
                {translateResourceString("/Wishlists/SaveUserNotesButton")}
            </Button>
        </div>
    )
}

export default WishlistUserNotes;